const firebaseConfig = {
  apiKey: "AIzaSyBoGsX5nv7EXwB4IV37Jwxzmz3QMbvhtpI",
  authDomain: "portaly-ca9e1.firebaseapp.com",
  databaseURL: "https://portaly-ca9e1-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "portaly-ca9e1",
  storageBucket: "portaly-ca9e1.appspot.com",
  messagingSenderId: "732722605559",
  appId: "1:732722605559:web:839613a5bb66c4c17ed2f2",
  measurementId: "G-22RPK6D2NL",
}

export default firebaseConfig
